import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Maintenance } from '@features/maintenance/maintenance';

@Component({
  standalone: true,
    selector: 'app-maintenance',
    templateUrl: './maintenance.component.html',
    styleUrl: './maintenance.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageMaintenanceComponent {
  @Input() maintenance!: Maintenance | null;
  currentYear = new Date().getFullYear();
}
